import {
  useState,
  useEffect,
} from "react";
import { useDispatch, useSelector } from "react-redux";

import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { getMedicamentoTexto, resetBuscadorMedicamentos } from "../../../../actions/recetasDigitales/RecetasDigitales";

const reg = new RegExp(/\./g);
export const BuscadorMedicamentos = ({ label, gestionAutorizacion, handleSelection, liquidaciones = false }) => {
  const dispatch = useDispatch();

  const [cod, setCod] = useState(null);
  const [loadingCod, setLoadingCod] = useState(false);
  const [parametroCod, setParametroCod] = useState("");

  const { buscadorMedicamentos } = useSelector((state) => state.medicamentos);

  const onChangeCodigoMedicamento = (e) => {
    let typingTimer = null;
    if (e.target.value.length > 0) {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        setParametroCod(e.target.value.toUpperCase());
      }, 700);
    } else {
      dispatch(resetBuscadorMedicamentos());
    }
  };

  useEffect(() => {
    setLoadingCod(x => !x);

    if (parametroCod.length > 0) dispatch(getMedicamentoTexto(parametroCod, liquidaciones));
    else dispatch(resetBuscadorMedicamentos());


    setLoadingCod(x => !x);
  }, [dispatch, parametroCod]);

  const handleChange = (val, reason) => {
    switch (reason) {
      case "clear":
        handleSelection([])
        setCod(null)
        break;
      default:
        typeof val === 'object' && setCod({ ...val, idMedicamento: val.idMedicamento });
        break;
    }

  }
  const handleSubmit = (e) => {
    e.preventDefault()
    if (cod !== null) handleSelection([cod])
    dispatch(resetBuscadorMedicamentos());
  }

  return (
    <form onSubmit={handleSubmit}>
      <Autocomplete
        value={cod}
        onChange={(e, newValue, reason) => {
          e.preventDefault();
          handleChange(newValue, reason)
          dispatch(resetBuscadorMedicamentos());
        }}
        options={buscadorMedicamentos}
        loading={loadingCod}
        loadingText="Buscando..."
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        getOptionLabel={(option) => (
          reg.test(`${option.presentacion} | ${option.laboratorio} | ${option.nombre} | ${option.drogas}`) ?
            `${option.presentacion} | ${option.laboratorio} | ${option.nombre} | ${option.drogas}` :
            `${option.presentacion} | ${option.laboratorio} | ${option.nombre.replace(reg, "")} | ${option.drogas}`
        )}
        renderOption={(option) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{`${option.presentacion} | ${option.laboratorio} | ${option.nombre} | ${option.drogas}`}</span>
          </div>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            style={{
              padding: gestionAutorizacion && 3,
            }}
            variant={gestionAutorizacion && "outlined"}
            onChange={onChangeCodigoMedicamento}
          />
        )}
      />
    </form>
  );
}